import { createStore } from 'effector';
import { UserGranularPermissions } from '@nx-frontend/shared/types';

export const initialUserGranularPermissionsState: UserGranularPermissions = {
  isLimitedInCurrentWorkspace: false,
};

export const $userGranularPermissions = createStore<UserGranularPermissions>(initialUserGranularPermissionsState);
